export const config = {
  useStore: true
}
